<template>
    <modal :id="modalId" size="xs" class="text-center">
        <h1 class="page-title">No appointments available</h1>
        <span class="block mt-4">Sorry, there are currently no appointments available.</span>
        <span class="block mt-4">Call 0330 678 0850 if you would like us to help you find a suitable appointment.</span>
    </modal>
</template>

<script>
    export default {
        name: 'no-appointments-available',

        props: {
            id: {
                type: Number,
                required: true,
            },
        },

        computed: {
            modalId() {
                return `no-appt-available-${this.id}`;
            },
        },
    }
</script>
